import { render, staticRenderFns } from "./TeoricasRejeitadasModal.vue?vue&type=template&id=302e5b3d&scoped=true"
import script from "./TeoricasRejeitadasModal.vue?vue&type=script&lang=js"
export * from "./TeoricasRejeitadasModal.vue?vue&type=script&lang=js"
import style0 from "./TeoricasRejeitadasModal.vue?vue&type=style&index=0&id=302e5b3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302e5b3d",
  null
  
)

export default component.exports